(function(algolia) {
  'use strict';
  algolia.translations = {
    search: algolia.localeCopy.current_search,
    noCollectionFound: algolia.localeCopy.no_collection,
    allProducts: algolia.localeCopy.all_products,
    matching: algolia.localeCopy.matching,
    sortBy: algolia.localeCopy.sort_by,
    relevance: algolia.localeCopy.relevance,
    outOf: algolia.localeCopy.out_of,
    resultsFound: algolia.localeCopy.results_found,
    oneResultFound: algolia.localeCopy.one_result,
    noResultFound: algolia.localeCopy.no_result,
    addToCart: algolia.localeCopy.add_to_cart,
    searchForProduct: algolia.localeCopy.search_products,
    selectedFilter: algolia.localeCopy.selected_filters,
    clearAll: algolia.localeCopy.clear_all,
    noPageFound: algolia.localeCopy.no_page,
    outOfStock: algolia.localeCopy.out_of_stock,
    showFilters: algolia.localeCopy.show_filters
  };
  algolia.facetTitles = {
    "price_range": algolia.localeCopy.price_range,
    "product_type": algolia.localeCopy.category,
    "tags": algolia.localeCopy.properties,
    "options.geschmack": algolia.localeCopy.flavour,
    "options.größe": algolia.localeCopy.size,
    "options.grosse": algolia.localeCopy.size,
    "price": algolia.localeCopy.price,
    "vendor": algolia.localeCopy.vendor
  };
  algolia.translation_helpers = {
    no_result_for: function(text, render) { return algolia.localeCopy.no_result_for.replace('__QUERY__', render(text)); },
    in: function() { return algolia.localeCopy.processing_time.replace('__SECONDS__', this.processingTimeMS / 1000); },
    try_clear_or_change_input: function(text, render) {
      var tags = text.match(/\x3c\/a>|\x3ca[a-z "-=]*>/g);
      if (!tags || tags.length !== 4) return '';
      return algolia.localeCopy.clear_suggestion_html.replace('__OPEN_CLEAR__',render(tags[0])).replace('__CLOSE_CLEAR__',render(tags[1])).replace('__OPEN_CHANGE__',render(tags[2])).replace('__CLOSE_CHANGE__',render(tags[3]));
    },
    outOf: function() { return (this.page * this.hitsPerPage + 1) + '–' + Math.min((this.page + 1) * this.hitsPerPage, this.nbHits) + ' ' + algolia.translations.outOf; },
    by: function(text, render) { return algolia.localeCopy.by.replace('__VENDOR__',render(text)); },
    translation: function(text, render) { return algolia.translations[render(text)]; }
  };
})(window.algoliaShopify);
